import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openProjectTooltip: {
		id: 'polaris-lib-project-tag.open-project-tooltip',
		defaultMessage: 'Go to {projectName} project',
		description: 'Tooltip for the link to open a project',
	},
});
